// extracted by mini-css-extract-plugin
export var container = "LoadingLogo_container__v20AI";
export var loading = "LoadingLogo_loading__rrsKD";
export var loadingImage = "LoadingLogo_loadingImage__mZ6MK";